import type { LucideIcon } from 'lucide-react'
import { BriefcaseBusiness, Building2, Factory, Gem, Landmark, Rocket, Sparkles, Store } from 'lucide-react'
import { cn } from '@/lib/utils'

export const projectIcons: Record<string, LucideIcon> = {
  building_2: Building2,
  briefcase: BriefcaseBusiness,
  rocket: Rocket,
  store: Store,
  landmark: Landmark,
  factory: Factory,
  gem: Gem,
  sparkles: Sparkles,
}

interface Props {
  project: { name: string; icon: string; logo_url: string | null }
  className?: string
}

export default function ProjectMark({ project, className }: Props) {
  const Icon = projectIcons[project.icon] || Building2

  return (
    <span className={cn('flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-border bg-muted/60 text-foreground', className)}>
      {project.logo_url ? <img src={project.logo_url} alt="" className="size-full object-cover" /> : <Icon className="size-[46%]" />}
    </span>
  )
}
